import { CloudOff } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { menuItems } from '../../constants/menu';
import { t } from '../../constants/translations';
import { useAdmin } from '../../contexts/admin.context';
import { useCafe } from '../../contexts/cafe.context';
import { useLocale } from '../../contexts/locale.context';
import useMedia from '../../utils/useMedia';
import LangSelect from '../LangSelect';
import Helpers from './Helpers/Helpers';
import Messages from './Messages/Messages';
import ProfileMenu from './ProfileMenu';

const Header = () => {
  const { pathname } = useLocation();
  const { lang } = useLocale();
  const { isMobile } = useMedia();
  const { cafe, online } = useAdmin();
  const { worker, isMultyUser, clearPin } = useCafe();
  const pageTitle = useMemo(
    () => menuItems.find((i) => i.route === pathname.split('/')[2])?.name || 'dashboard',
    [pathname]
  );

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        p: isMobile ? 1 : 2,
        overflow: 'hidden',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mx: isMobile ? 1 : 2 }}>
        <Typography variant={isMobile ? 'subtitle1' : 'h5'}>{pageTitle && t[pageTitle][lang]}</Typography>
        {online && <Helpers />}

        {!online && (
          <>
            <CloudOff color="error" />
            <Typography color={(t) => t.palette.error.dark}>OFFLINE</Typography>
          </>
        )}
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Messages />
        <LangSelect />
        <ProfileMenu worker={worker} isMultyUser={isMultyUser} clearPin={clearPin} restaurantName={cafe?.name} />
      </Box>
    </Box>
  );
};

export default Header;
